import { createReducer, on } from '@ngrx/store';
import { TenantUser } from '@core/interfaces/tenant-user';
import { DataItemAddUsersAction } from '../actions/data.action';
import { DataState } from '../data.state';

const initialDataState: DataState = {
  users: [],
};

export const dataActionReducer = createReducer(
  initialDataState,
  on(DataItemAddUsersAction, (state, { items }): { users: TenantUser[] } => ({ ...state, users: items })),
);
